import { vsingleton } from '@niknevis/vue-modules'
import Vue from 'vue'

@vsingleton()
export default class EditorStore {
  private data = Vue.observable({ imageUploadLoading: false })

  get isUploadingImage() {
    return this.data.imageUploadLoading
  }

  setImageUploadLoading(value: boolean) {
    Vue.set(
      this.data,
      'imageUploadLoading',
      typeof value === 'boolean' ? value : false
    )
  }
}
